import React, { Component, Fragment } from "react";
import moment from "moment";

import { inject, observer } from "mobx-react";

import {
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    FormControl,
    InputAdornment,
    Input,
    FormHelperText,
    Switch,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Typography,
    Popover
} from "@material-ui/core";

import NumberFormat from "react-number-format";
import { ProfileType, BookingStatusType, BookingType, LegalEntityType } from "../../../types/enum";
import { legalEntityHasSuper } from "../../../helper/legalEntityHelper";
import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";
import superCalculationHelper from "../../../helper/superCalculationHelper.js"

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const ENABLE_SUBSCRIPTION = process.env.REACT_APP_ENABLE_SUBSCRIPTION === "true";
const styles = theme => ({
    margin: {
        margin: theme.spacing.unit
    }
});
@inject("bookingRequestStore", "profileStore", "agentVenueStore", "agentActStore", "templateStore", "commonStore")
@observer
class BookingFeeDetails extends Component {
    state = {
        approvalDialogOpen: false,
        checked: false,
        anchorEl: false,
    };

    handleEntertainerBooking() {
        let {booking} = this.props.bookingRequestStore;
        var currentProfile = this.props.profileStore.currentProfile;
        if((!booking || !booking.id) && currentProfile?.type === ProfileType.Musician.ordinal){
            if(legalEntityHasSuper(currentProfile?.legalEntity)){
                 this.props.bookingRequestStore.setSuperEntertainer(true)
                  this.handleSetIsSuperFee(currentProfile?.legalEntity)
                  this.handleActFeeChangeSuperLocal()
            // if(legalEntityHasSuper(act?.actAdmin?.legalEntity)){
            //     this.handleActFeeChangeSuperLocal()
            // }
            }
              
        }
       
    }

    handleExtraGigFeeChange = e => {
        let extraGigFee = e.target.value < 0 ? 0 : e.target.value;
        this.props.bookingRequestStore.setBooking("extraGigFee", extraGigFee);
    };

    handleRequestApprovalClick = () => {
        let extraGigFee = this.props.bookingRequestStore.booking.extraGigFee;

        if (extraGigFee === 0 || extraGigFee === "0") {
            this.props.templateStore.openSnackbar("Extra set fee must be more than 0");
            return;
        } else if (!extraGigFee) {
            this.props.templateStore.openSnackbar("Please fill the extra set fee amount");
            return;
        }

        this.props.templateStore.showLoadingScreen();
        this.props.bookingRequestStore
            .requestExtraGigFee(this.props.bookingRequestStore.booking.id, extraGigFee)
            .then(response => {
                this.props.templateStore.openSnackbar("Request approval for extra set fee has been sent");
                this.props.bookingRequestStore.setBooking("isApprovalSent", true);
            })
            .finally(e => {
                this.props.templateStore.hideLoadingScreen();
            });
    };

    handleRequestApprovedClick = () => {
        this.props.templateStore.showLoadingScreen();
        this.props.bookingRequestStore
            .approveExtraGigFee(this.props.bookingRequestStore.booking.id, this.props.profileStore.currentProfile?.id)
            .then(response => {
                this.props.templateStore.openSnackbar("Extra set fee has been approved");
                this.props.bookingRequestStore.setBooking("extraGigFeeApprovalById", this.props.profileStore.currentProfile?.id);
                this.props.bookingRequestStore.setBooking("extraGigFeeApprovalAt", new Date());
                this.props.bookingRequestStore.setBooking("isApproved", true);
            })
            .finally(e => {
                this.props.templateStore.hideLoadingScreen();
                this.closeApprovalDialog();
            });
    };

    handleRequestDeclinedClick = () => {
        this.props.templateStore.showLoadingScreen();
        this.props.bookingRequestStore
            .declineExtraGigFee(this.props.bookingRequestStore.booking.id, this.props.profileStore.currentProfile?.id)
            .then(response => {
                this.props.templateStore.openSnackbar("Extra set fee has been declined");
                this.props.bookingRequestStore.setBooking("extraGigFeeApprovalById", this.props.profileStore.currentProfile?.id);
                this.props.bookingRequestStore.setBooking("extraGigFeeApprovalAt", new Date());
                this.props.bookingRequestStore.setBooking("isApproved", false);
            })
            .finally(e => {
                this.props.templateStore.hideLoadingScreen();
                this.closeApprovalDialog();
            });
    };

    openApprovalDialog = () => {
        this.setState({
            approvalDialogOpen: true,
            checked: false
        });
    };

    closeApprovalDialog = () => {
        this.setState({ approvalDialogOpen: false });
    };

    handleCheckedChange = e => {
        this.setState({ checked: e.target.checked });
    };
    // handleGigFeeChange = e => {
    //     const { agentCommissionType, agentCommissionFee } = this.props.bookingRequestStore.booking;
    //     let actGigFee = 0;
    //     let agentCommission = 0;
    //     let value = e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
    //     value = !value ? '' : value

    //     if (agentCommissionType === 0) {
    //         actGigFee = parseFloat(value) - parseFloat(agentCommissionFee);
    //         agentCommission = agentCommissionFee;
    //     } else if (agentCommissionType === 1) {
    //         agentCommission = (parseFloat(agentCommissionFee) / 100) * parseFloat(value);
    //         actGigFee = parseFloat(value) - agentCommission;
    //     }

    //     this.props.bookingRequestStore.setBooking("gigFee", value);
    //     this.props.bookingRequestStore.setBooking("actFee", actGigFee);
    //     this.props.bookingRequestStore.setBooking("agentCommissionAmount", agentCommission);
    // };

    // handleGigFeeChangeSuper = e => {
    //     const { agentCommissionType, agentCommissionFee, includeSuper } = this.props.bookingRequestStore.booking;
    //     let actGigFee = 0;
    //     let agentCommission = 0;
    //     let value = e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
    //     value = !value ? '' : value

    //     if (agentCommissionType === 0) {
    //         actGigFee = parseFloat(value) - parseFloat(agentCommissionFee);
    //         agentCommission = agentCommissionFee;
    //     } else if (agentCommissionType === 1) {
    //         agentCommission = (parseFloat(agentCommissionFee) / 100) * parseFloat(value);
    //         actGigFee = parseFloat(value) - agentCommission;
    //     }
    //     var superFee = 0.12 * parseFloat(actGigFee)
    //     if(includeSuper){
    //         this.props.bookingRequestStore.setBooking("totalFee", value);
    //     }else{
    //         var totalFee = parseFloat(value) + superFee
    //         this.props.bookingRequestStore.setBooking("totalFee", totalFee);
    //     }
    //     this.props.bookingRequestStore.setBooking("superFee", superFee);
    //     this.props.bookingRequestStore.setBooking("gigFee", value);
    //     this.props.bookingRequestStore.setBooking("actFee", actGigFee);
    //     this.props.bookingRequestStore.setBooking("agentCommissionAmount", agentCommission);
    // };

    handleActFeeChange = e => {
        let value = e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
         value = this.handleZeroRemovalNumber(value)

        value = !value ? '' : value
        this.props.bookingRequestStore.setBooking("actFee", value);
    };

    removeLeadingZerosRegex(str) {
        if (str === null) {
            return null;
        }
        // The regex /^0+(?!$)/ matches one or more leading '0's (0+)
        // at the beginning of the string (^)
        // BUT only if they are NOT followed by the end of the string (?!$)
        // This ensures that a string like "000" becomes "0" instead of ""
        const result = str.replace(/^0+(?!$)/, '');

        // If the string was "000", the regex makes it "", so we convert to "0"
        // If the string was "0", the regex does nothing, it remains "0"
        // If the string was "001", the regex makes it "1"
        return result === '' && str.includes('0') ? '0' : result;
    }
    handleActFeeChangeSuper = e => {
        const { percentageFeeSuper,agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee , includeSuper, isSuperFee} = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        let value = this.removeLeadingZerosRegex(e.target.value)
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        
        value = !value ? '' : value
        this.props.bookingRequestStore.setBooking("actFee", value);
        var performanceFee = value
        if(value){
            if(agentCommissionFee && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Staff.ordinal)){
                value = parseFloat(value) + parseFloat(agentCommissionFee)
            }
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(performanceFee)).toFixed(2))
                if(includeSuper){
                    var feeWithoutSuper = (parseFloat(performanceFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(performanceFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", value);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }else{
                    var totalFee = parseFloat(value) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", value);
                this.props.bookingRequestStore.setBooking("gigFee", value);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", 0);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

    handleActFeeChangeSuperLocal = () => {
        const { percentageFeeSuper,agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee , includeSuper, isSuperFee, actFee} = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        if(!actFee) return;
        let value = this.removeLeadingZerosRegex(actFee.toString())
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        
        value = !value ? '' : value
        this.props.bookingRequestStore.setBooking("actFee", value);
        var performanceFee = value
        if(value){
            if(agentCommissionFee && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Staff.ordinal)){
                value = parseFloat(value) + parseFloat(agentCommissionFee)
            }
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(performanceFee)).toFixed(2))
                if(includeSuper){
                    var feeWithoutSuper = (parseFloat(performanceFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(performanceFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", value);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }else{
                    var totalFee = parseFloat(value) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                    this.props.bookingRequestStore.setBooking("gigFee", value);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", value);
                this.props.bookingRequestStore.setBooking("gigFee", value);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", 0);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

    handleGigFeeChange = e => {
         let value = this.removeLeadingZerosRegex(e.target.value)
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        value = !value ? '' : value
        const { agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee } = this.props.bookingRequestStore.booking;
        this.props.bookingRequestStore.setBooking("gigFee", value);
        var actFee = 0;
        if (agentCommissionType === 0) {
            actFee = value - (agentCommissionFee ? agentCommissionFee : 0);
        } else if (agentCommissionType === 1 && value !== 0) {
            if (parseFloat(agentCommissionFee) > 100 || parseFloat(agentCommissionFee) < 0) return false;
            let diffFee = (value / 100) * agentCommissionFee;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            actFee = parseFloat(value - diffFee).toFixed(2);

        }
        this.props.bookingRequestStore.setBooking("actFee", actFee);
    };

    handleGigFeeChangeSuper = e => {
         let value = this.removeLeadingZerosRegex(e.target.value)
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        value = !value ? '' : value
        const { percentageFeeSuper, agentCommissionType, agentCommissionFee, agentCommissionAmount, gigFee , includeSuper, isSuperFee} = this.props.bookingRequestStore.booking;

        this.props.bookingRequestStore.setBooking("gigFee", value);
        var actFee = 0;
        if (agentCommissionType === 0) {
            actFee = value - (agentCommissionFee ? agentCommissionFee : 0);
        } else if (agentCommissionType === 1 && value !== 0) {
            if (parseFloat(agentCommissionFee) > 100 || parseFloat(agentCommissionFee) < 0) return false;
            let diffFee = (value / 100) * agentCommissionFee;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            actFee = parseFloat(value - diffFee).toFixed(2);

        }
        if(value !== 0){
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(value)).toFixed(2))
                if(includeSuper){
                    var feeWithoutSuper = (parseFloat(value) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(value) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", value);
                }else{
                    var totalFee = parseFloat(value) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", value);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
        }
        this.props.bookingRequestStore.setBooking("actFee", actFee);
    };

    handleGigFeeStaffChange = e => {
        const { includeSuper, act, percentageFeeSuper, isSuperFee } = this.props.bookingRequestStore.booking

        var rawValue = e.target.value.replace(/[^0-9.]/g, '');
        var parts = rawValue.split('.');
        if (parts.length > 2) {
            rawValue = parts[0] + '.' + parts.slice(1).join('');
        }

        this.props.bookingRequestStore.setBooking("gigFee", rawValue);
        this.props.bookingRequestStore.setBooking("actFee", rawValue);

        var fee = parseFloat(rawValue) || 0

        if (isSuperFee) {
            var superFee = parseFloat((percentageFeeSuper / 100 * parseFloat(fee)).toFixed(2))
            this.props.bookingRequestStore.setBooking("superFee", superFee ? superFee : 0);
            if (includeSuper) {
                var feeWithoutSuper = (parseFloat(fee) / ((percentageFeeSuper + 100) / 100))
                superFee = (parseFloat(fee) - feeWithoutSuper).toFixed(2)
                this.props.bookingRequestStore.setBooking("totalFee", fee);
            } else {
                var totalFee = fee + superFee
                this.props.bookingRequestStore.setBooking("totalFee", totalFee ? totalFee : 0);
            }
        } else {
            this.props.bookingRequestStore.setBooking("totalFee", fee);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

    handleAgentCommissionAmountChange = e => {
        
        this.props.bookingRequestStore.setBooking("agentCommissionAmount", e.target.value);
    };

    handleCommissionTypeChange = e => {
        this.props.bookingRequestStore.setBooking("agentCommissionType", e.target.value);
        this.props.bookingRequestStore.setBooking("agentCommissionFee", 0);
        // this.props.bookingRequestStore.setBooking("actFee", 0);
        this.props.bookingRequestStore.setBooking("totalFee", parseFloat(this.props.bookingRequestStore.booking?.totalFee) - parseFloat(this.props.bookingRequestStore.booking?.agentCommissionAmount));

        this.props.bookingRequestStore.setBooking("agentCommissionAmount", 0);

    
        // this.props.bookingRequestStore.setBooking("superFee", 0);
    };

    handleZeroRemovalNumber = value => {
        if (value.length > 1 && value.charAt(0) === '0' && value.indexOf('.') === -1) {
            value = parseFloat(value).toString();
            return value
        }
        return value

    }

     handleAgentCommissionChangeSuper = e => {
        const { actFee, agentCommissionType, superFee, includeSuper, isSuperFee } = this.props.bookingRequestStore.booking;
         let value = this.removeLeadingZerosRegex(e.target.value)
        
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')

        value = !value ? '' : value
        let result = 0.0;
        if (agentCommissionType === 0) {
            if (parseFloat(value) > parseFloat(actFee)) return false;
            result = (parseFloat(actFee) || 0) + parseFloat(value);
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", value);
        } else if (agentCommissionType === 1 && actFee !== 0) {
            if (parseFloat(value) > 100 || parseFloat(value) < 0) return false;
            let diffFee = (parseFloat(actFee) / 100) * parseFloat(value);
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            result = parseFloat(parseFloat(actFee) + parseFloat(diffFee)).toFixed(2);
        }
        this.props.bookingRequestStore.setBooking("agentCommissionFee", value);
        this.props.bookingRequestStore.setBooking("gigFee", result);

        if(isSuperFee){
            if(includeSuper){
                this.props.bookingRequestStore.setBooking("totalFee", result);
            }else{
                 var totalFee = parseFloat(result) + parseFloat(superFee)
                this.props.bookingRequestStore.setBooking("totalFee", totalFee);
            }
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", result);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
    };

    handleAgentCommissionChange = e => {
        const { gigFee, percentageFeeSuper, agentCommissionType, includeSuper, isSuperFee} = this.props.bookingRequestStore.booking;

         let value = this.removeLeadingZerosRegex(e.target.value)
        value = value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
       
        value = !value ? '' : value
        let result = 0.0;
        if (agentCommissionType === 0) {
            if (parseFloat(value) > parseFloat(gigFee)) return false;
            result = (gigFee || 0) - e.target.value;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", value);
        } else if (agentCommissionType === 1 && gigFee !== 0) {
            if (parseFloat(value) > 100 || parseFloat(value) < 0) return false;
            let diffFee = (gigFee / 100) * value;
            this.props.bookingRequestStore.setBooking("agentCommissionAmount", parseFloat(diffFee).toFixed(2));
            result = parseFloat(gigFee - diffFee).toFixed(2);
        }
        if(isSuperFee){
            var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(result)).toFixed(2))
            if(includeSuper){
                var feeWithoutSuper = (parseFloat(result) / ((percentageFeeSuper+100)/100))
                superFee = (parseFloat(result) - feeWithoutSuper).toFixed(2)
                this.props.bookingRequestStore.setBooking("totalFee", value);
            }else{
                var totalFee = parseFloat(gigFee) + superFee
                this.props.bookingRequestStore.setBooking("totalFee", totalFee);
            }
            this.props.bookingRequestStore.setBooking("superFee", superFee);
        }else{
            this.props.bookingRequestStore.setBooking("totalFee", gigFee);
            this.props.bookingRequestStore.setBooking("superFee", 0);
        }
        this.props.bookingRequestStore.setBooking("agentCommissionFee", value);
        this.props.bookingRequestStore.setBooking("actFee", result);
    };

    handleIncludeSuperFeeChanged = (e, checked) => {
        const { gigFee, actFee, percentageFeeSuper, isSuperFee } = this.props.bookingRequestStore.booking;

         if(gigFee){
            if(isSuperFee){
                var superFee = parseFloat((percentageFeeSuper/100 * parseFloat(actFee)).toFixed(2))
                if(checked){
                    var feeWithoutSuper = (parseFloat(actFee) / ((percentageFeeSuper+100)/100))
                    superFee = (parseFloat(actFee) - feeWithoutSuper).toFixed(2)
                    this.props.bookingRequestStore.setBooking("totalFee", gigFee);
                }else{
                    var totalFee = parseFloat(gigFee) + superFee
                    this.props.bookingRequestStore.setBooking("totalFee", totalFee);
                }
                this.props.bookingRequestStore.setBooking("superFee", superFee);
            }else{
                this.props.bookingRequestStore.setBooking("totalFee", gigFee);
                this.props.bookingRequestStore.setBooking("superFee", 0);
            }
             this.setState({
            ...this.state
        });
        }
         this.props.bookingRequestStore.setBooking("includeSuper", checked);
    };

    handleImmediateInvoiceChange = (e, checked) => {
        this.props.bookingRequestStore.setBooking("immediateInvoice", checked);
        this.setState({
            ...this.state
        });
    };
    handleGigFeeEntertainerChange = e => {
        const { currentProfile } = this.props.profileStore;
        this.props.bookingRequestStore.setBooking("gigFee", e.target.value);
        if (currentProfile?.type === ProfileType.Musician.ordinal) {
            this.props.bookingRequestStore.setBooking("actFee", e.target.value);
        }
    };

    checkBookingStatus = status => {
        return (
            status === BookingStatusType.New.ordinal ||
            status === BookingStatusType.Declined.ordinal ||
            status === BookingStatusType.Hold.ordinal ||
            status === BookingStatusType.Cancelled.ordinal ||
            status === BookingStatusType.Resent.ordinal
        );
    };

    handleBalanceDueDateChange = e => {
        this.props.bookingRequestStore.setBooking("balanceDueDate", moment(e).startOf("day"));
    };

    handlePopoverOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleSetIsSuperFee = value => {
        this.props.bookingRequestStore.setBooking("isSuperFee", legalEntityHasSuper(value))
        
    }
    handlePopoverClose = () => {
        this.setState({ anchorEl: false });
    };

    render() {
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        const { classes } = this.props;
        const {isActChange} = this.props

        this.handleEntertainerBooking()
        let { booking, error, isSuperEntertainer, bookableActs} = this.props.bookingRequestStore;
        let {
            isApproved,
            extraGigFeeApprovalById,
            isApprovalSent,
            includeSuper,
            gigFee,
            agentCommissionFee,
            actFee,
            agentCommissionType,
            agentCommissionAmount,
            status,
            immediateInvoice,
            isAdmin,
            createdById,
            dateStart,
            extraGigFee,
            balanceDueDate,
            createInvoice,
            createdBy,
            superFee,
            totalFee,
            act,
            isSuperFee,
            percentageFeeSuper,
            isBookingCreator,
            actId
        } = booking;
        let { readOnly } = this.props;
        const { currentProfile } = this.props.profileStore;
        const isStaff = currentProfile && currentProfile?.type === ProfileType.Staff.ordinal;
        let currencySymbol = currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$";

        var calculateSuperFee =  booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(actFee,percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(actFee,percentageFeeSuper)
        var feeWithoutSuperFee = parseFloat(actFee) - calculateSuperFee??0
        const { token } = this.props.commonStore;
        let hasSubscribe = false;
        if (token && currentProfile) hasSubscribe = true;

        if (!ENABLE_SUBSCRIPTION) {
            hasSubscribe = true;
        }
        //for checking if profile is in lineup booking
        let onLineup = false;
        if (booking.lineups && booking?.lineups?.length && booking.lineups[0] !== undefined) {
            if (booking?.lineups?.find(x => x.profileId == currentProfile?.id)) {
                onLineup = true
            }
        }
        var lineupSuperFee = false
        let lineupFee = 0;
        let lineupFeeWithoutSuper = 0;
        var superFeeLineup = 0;
        if (onLineup) {
            booking?.lineups?.forEach(x => {
                if (x.profileId == currentProfile?.id) {
                    lineupFee = Number(x.fee).toFixed(2)
                    if(legalEntityHasSuper(x.profile?.legalEntity)){
                        superFeeLineup = Number(x.superFee).toFixed(2)
                        lineupFeeWithoutSuper = lineupFee - (booking.isPayByActOwner ? superFeeLineup : booking.includeSuper ? superFeeLineup : 0)
                    }
                    lineupSuperFee = x.isSuperFee
                  
                    
                }
            })
        }
        let isPlayerLineupVenueBooking = false;
        if (onLineup && booking?.type == BookingType.Normal.ordinal && booking?.createdBy?.type !== ProfileType.Musician.ordinal) {
            isPlayerLineupVenueBooking = true;
        }

        if((actId && !booking?.id)){
            var selectedActs = bookableActs.filter(x=>x.id == actId)
            if(selectedActs && selectedActs.length){
                var selectedAct = selectedActs[0]
                    if(legalEntityHasSuper(selectedAct?.actAdmin?.legalEntity)){
                    this.handleSetIsSuperFee(selectedAct?.actAdmin?.legalEntity)
                    this.handleActFeeChangeSuperLocal()
                }
            }
           
        }

         if(isActChange){
            this.handleSetIsSuperFee(act?.actAdmin?.legalEntity)
            if(legalEntityHasSuper(act?.actAdmin?.legalEntity)){
                this.handleActFeeChangeSuperLocal()
            }
           
        }
        

        let isActOwer = false
        if(booking.bookingRequests && booking.bookingRequests[0] !== undefined) {
            if(booking.bookingRequests[booking.bookingRequests.length - 1]?.act?.actAdminId == currentProfile?.id) isActOwer = true
        } else {
            if (booking?.act?.actAdminId == currentProfile?.id) isActOwer = true
        }
        let NumberFormatCustom = props => {
            const { inputRef, onChange, ...other } = props;

            return (
                <NumberFormat
                    {...other}
                    ref={inputRef}
                    onValueChange={values => {
                        onChange({
                            target: {
                                value: values.value
                            }
                        });
                    }}
                    thousandSeparator
                    prefix={currencySymbol}
                />
            );
        };

        let modGigFee = parseFloat(agentCommissionFee) > parseFloat(gigFee);

        let confirmedEditable =
            status !== BookingStatusType.Cancelled.ordinal &&
            status !== BookingStatusType.Completed.ordinal &&
            moment(dateStart).endOf("day") >= moment() &&
            (!createdById || createdById === currentProfile?.id || isStaff);
        return (
            <React.Fragment>
                {booking.id ? (
                    <Grid container spacing={8}>
                        <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="isPayByActOwner">Act Player Invoices Paid by Hirer</InputLabel>
                                <Input
                                    id="isPayByActOwner"
                                    value={booking.isPayByActOwner ? "No" : "Yes"}
                                    readOnly={true}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                ) : null}
                {currentProfile && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Musician.ordinal) ? (
            <Grid container spacing={8}>
                {currentProfile?.type === ProfileType.Musician.ordinal ? (
                    booking.type === BookingType.Adhoc.ordinal ? (
                        <React.Fragment>
                            <Grid item xs={12} lg={6} className="gridBookingForm">
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="gigFee">{booking.isAdmin ? "Gig Fee Paid to Act (ex Tax)" : "Gig Fee (ex Tax)"}</InputLabel>
                                    <Input
                                        id="gigFee"
                                        type="string"
                                        value={actFee}
                                        onChange={this.handleActFeeChange}
                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                        readOnly={readOnly}
                                    />
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth>
                                <MuiPickersUtilsProvider utils={MomentUtils} fullWidth>
                                    <DatePicker
                                        className="booking-date-picker"
                                        keyboard
                                        value={moment(balanceDueDate)}
                                        fullWidth
                                        margin="dense"
                                        onChange={this.handleBalanceDueDateChange}
                                        label="Due Date"
                                        minDate={booking.id ? undefined : moment().startOf("days")}
                                        maxDate={moment(dateStart).endOf("days")}
                                        format="DD-MM-YYYY"
                                        keyboardIcon={<EventIcon />}
                                        leftArrowIcon={<KeyboardArrowLeftIcon />}
                                        rightArrowIcon={<KeyboardArrowRightIcon />}
                                        style={{ marginTop: 0 }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                        </Grid> */}
                            <Grid item xs={12} className="gridBookingForm">
                                <FormControlLabel
                                    control={
                                        immediateInvoice ? (
                                            <Switch
                                                color="primary"
                                                checked={true}
                                                onChange={this.handleImmediateInvoiceChange}
                                                disabled={!confirmedEditable}
                                            />
                                        ) : (
                                            <Switch
                                                color="primary"
                                                checked={false}
                                                onChange={this.handleImmediateInvoiceChange}
                                                disabled={!confirmedEditable}
                                            />
                                        )
                                    }
                                    label="Immediate invoice (ignores invoice batching)"
                                />
                            </Grid>
                        </React.Fragment>) :
                        (
                            (!booking || !booking.id && isSuperEntertainer) || (booking && booking.createdById === currentProfile?.id && booking.createdBy?.type === ProfileType.Musician.ordinal) ? 
                            <Fragment>
                                 <Grid item xs={12} lg={6} className="gridBookingForm">
                                        <FormControl fullWidth error={error && error["actFee"]}>
                                        <InputLabel htmlFor="actFee">Performance Fee (ex Tax)</InputLabel>
                                        <Input
                                            id="actFeeAmount"
                                            type="string"
                                            value={actFee}
                                            onChange={this.handleActFeeChangeSuper}
                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                            readOnly={readOnly}
                                        />
                                        {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} className="gridBookingForm">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                    color="primary"
                                                    checked={includeSuper}
                                                    onChange={this.handleIncludeSuperFeeChanged}
                                                    disabled={readOnly}
                                            />
                                        }
                                        label="Fee includes super"
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["totalFee"]}>
                                                    <InputLabel htmlFor="totalFee">Total Fee to Venue (ex Tax)</InputLabel>
                                                    <Input
                                                        type="text"
                                                        id="totalFee"
                                                        value={Number(totalFee || 0).toFixed(2)}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        readOnly={true}
                                                    />
                                                    {error && error["totalFee"] ? <FormHelperText>{error["totalFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["superFee"]}>
                                                    <InputLabel htmlFor="superFee">Super Paid to Act</InputLabel>
                                                    <Input
                                                        id="superFee"
                                                        value={superFee}
                                                        type="string"
                                                        readOnly={true}
                                                        inputprops={{
                                                            inputComponent: NumberFormatCustom
                                                        }}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    />
                                                    {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                                <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of Performance Fee paid to act`}</FormHelperText>
                                            </Grid>
                                             <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["superFee"]}>
                                                    <InputLabel htmlFor="superFee">Total Act Invoice</InputLabel>
                                                    <Input
                                                        id="actInvoiceAmount"
                                                        value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                                        type="string"
                                                        readOnly={true}
                                                        inputprops={{
                                                            inputComponent: NumberFormatCustom
                                                        }}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    />
                                                    {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                                                </FormControl>
                                            </Grid>
                            </Fragment>
                                 :
                            <React.Fragment>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth>
                                                                        {/* on act owner private booking*/}                                                                      {/* on player lineup venue booking*/}                                                          {/* on player lineup and act owner venue booking*/}                                                                                                                                           {/* on booking creator private booking*/}                                                          {/* on player lineup and act owner venue booking*/}
                                        <InputLabel htmlFor="gigFee">{(booking?.act?.actAdminId == currentProfile?.id && booking.type == BookingType.Adhoc.ordinal) ? "Gig Fee (ex Tax)" : isPlayerLineupVenueBooking && booking?.act?.actAdminId !== currentProfile?.id? "Your Fee (ex Tax)" : ((onLineup || isActOwer) && booking?.type == BookingType.Normal.ordinal && booking?.createdBy?.type !== ProfileType.Musician.ordinal) ? isSuperFee ? "Performance Fee (ex tax)" : "Gig Fee Paid to Act (ex Tax)" : "Gig Fee to Client (ex Tax)"} </InputLabel>
                                        <Input
                                            id="gigFee"
                                            type="text"
                                            value={
                                                Number(
                                                    isActOwer && booking?.createdById !== currentProfile?.id
                                                        ? booking?.actFee
                                                        : isPlayerLineupVenueBooking
                                                            ? lineupFee
                                                            : booking?.gigFee
                                                            || 0).toFixed(2)
                                            }
                                            onChange={this.handleGigFeeEntertainerChange}
                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                            readOnly={readOnly}
                                        />
                                    </FormControl>
                                </Grid>
                                {(booking.isSuperFee && legalEntityHasSuper(currentProfile?.legalEntity)) || (lineupSuperFee && isPlayerLineupVenueBooking)? 
                                <Fragment>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth>                                                                                                                                         {/* on booking creator private booking*/}                                                          {/* on player lineup and act owner venue booking*/}
                                        <InputLabel htmlFor="gigFee">Super Contribution</InputLabel>
                                            <Input
                                                id="gigFee"
                                                type="text"
                                                value={
                                                    (() => {
                                                        const actFeeVal = parseFloat(actFee) || 0;
                                                        const percentageVal = parseFloat(percentageFeeSuper) || 0;

                                                        const val = isActOwer
                                                            ? booking?.includeSuper
                                                                ? actFeeVal - (actFeeVal / ((percentageVal + 100) / 100))
                                                                : (actFeeVal * percentageVal) / 100
                                                            : parseFloat(superFeeLineup) || 0;

                                                        return Number(val).toFixed(2);
                                                    })()
                                                }
                                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                readOnly={true}
                                            />
                                    </FormControl>
                                </Grid>
                                 <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth>                                                                                                                                         {/* on booking creator private booking*/}                                                          {/* on player lineup and act owner venue booking*/}
                                        <InputLabel htmlFor="gigFee">Invoice Amount</InputLabel>
                                            <Input
                                                id="gigFee"
                                                type="text"
                                                value={
                                                    Number(
                                                        isActOwer && booking?.createdById !== currentProfile?.id
                                                            ? isSuperFee
                                                                ? includeSuper
                                                                    ? feeWithoutSuperFee
                                                                    : actFee
                                                                : actFee
                                                            : isPlayerLineupVenueBooking
                                                                ? lineupFeeWithoutSuper
                                                                : gigFee
                                                    ).toFixed(2)
                                                }
                                                startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                readOnly={true}
                                            />
                                    </FormControl>
                                </Grid>
                                    </Fragment> : null}

                                {(!booking.id || currentProfile?.id === booking.createdById) &&
                                    <Grid item xs={12} lg={6} className="gridBookingForm">
                                        <FormControl fullWidth>
                                            <MuiPickersUtilsProvider utils={MomentUtils} fullWidth>
                                                <DatePicker
                                                    className="booking-date-picker"
                                                    keyboard
                                                    value={moment(balanceDueDate)}
                                                    fullWidth
                                                    margin="dense"
                                                    onChange={this.handleBalanceDueDateChange}
                                                    label="Due Date"
                                                    minDate={booking.id ? undefined : moment().startOf("days")}
                                                    maxDate={moment(dateStart).endOf("days")}
                                                    format="DD-MM-YYYY"
                                                    keyboardIcon={<EventIcon />}
                                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                                    style={{ marginTop: 0 }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </FormControl>
                                    </Grid>}
                                <br />
                                {
                                    isBookingCreator ?   <Grid container spacing={2} className="gridBookingForm">
                                    <Grid item xs={12} lg={6} className="gridBookingForm">
                                        <FormControlLabel
                                            onMouseOver={this.handlePopoverOpen}
                                            control={
                                                <Switch
                                                    color="primary"
                                                    onChange={(e, checked) => this.props.bookingRequestStore.setBooking("createInvoice", checked)}
                                                    checked={createInvoice && hasSubscribe}
                                                    disabled={!confirmedEditable || !hasSubscribe}
                                                />
                                            }
                                            label="Create Invoices"
                                        />
                                    </Grid>
                                    <Popover
                                        id="mouse-over-popover"
                                        open={open && !hasSubscribe}
                                        anchorEl={anchorEl}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left"
                                        }}
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "left"
                                        }}
                                        onClose={this.handlePopoverClose}
                                        disableRestoreFocus
                                    >
                                        <div onMouseLeave={this.handlePopoverClose}>
                                            <Typography className={classes.margin}>Upgrade to enable automated invoicing</Typography>
                                            <Grid container xs={12} justify="center" className={classes.margin}>
                                                <Grid item>
                                                    <Button align="center" variant="contained" color="primary" onClick={this.handleGoToPaymentpage}>
                                                        Upgrade
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Popover>
                                    <Grid item xs={12} lg={6} className="gridBookingForm">
                                        <FormControlLabel
                                            control={
                                                immediateInvoice ? (
                                                    <Switch
                                                        color="primary"
                                                        checked={true}
                                                        onChange={this.handleImmediateInvoiceChange}
                                                        disabled={!confirmedEditable}
                                                    />
                                                ) : (
                                                    <Switch
                                                        color="primary"
                                                        checked={false}
                                                        onChange={this.handleImmediateInvoiceChange}
                                                        disabled={!confirmedEditable}
                                                    />
                                                )
                                            }
                                            label="Immediate invoice (ignores invoice batching)"
                                        />
                                    </Grid>
                                </Grid> : null
                                }
                              
                            </React.Fragment>
                        )
                ) :
                    <Fragment>
                        {/* show only when booking venue shown on act owner booking who not created the booking */}
                        {booking?.act?.actAdminId == currentProfile?.id && booking?.type == BookingType.Normal.ordinal && booking?.createdBy?.type == ProfileType.Agent.ordinal && currentProfile?.id !== booking?.createdBy?.id ?
                            <Fragment>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth error={error && error["actFee"]}>
                                        <InputLabel htmlFor="actFee">Gig Fee Paid To Act (ex Tax)</InputLabel>
                                        <Input
                                            id="actFeeAmount"
                                            type="string"
                                            value={actFee}
                                            onChange={this.handleActFeeChange}
                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                            readOnly
                                        />
                                        {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} className="gridBookingForm">
                                    <FormControlLabel
                                        control={
                                            immediateInvoice ? (
                                                <Switch
                                                    color="primary"
                                                    checked={true}
                                                    onChange={this.handleImmediateInvoiceChange}
                                                    disabled={!confirmedEditable}
                                                />
                                            ) : (
                                                <Switch
                                                    color="primary"
                                                    checked={false}
                                                    onChange={this.handleImmediateInvoiceChange}
                                                    disabled={!confirmedEditable}
                                                />
                                            )
                                        }
                                        label="Immediate invoice (ignores invoice batching)"
                                    />
                                </Grid>
                            </Fragment> :
                            !legalEntityHasSuper(act?.actAdmin?.legalEntity) || !isSuperFee? 
                            <Fragment>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth error={error && error["gigFee"]}>
                                        <InputLabel htmlFor="venueFee">Gig Fee to Venue (ex Tax)</InputLabel>
                                        <Input
                                            type="string"
                                            id="venueFee"
                                            value={gigFee}
                                            onChange={this.handleGigFeeChange.bind(this)}
                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                            readOnly={readOnly}
                                        />
                                        {error && error["gigFee"] ? <FormHelperText>{error["gigFee"]}</FormHelperText> : ""}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth error={error && error["agentCommissionFee"]}>
                                        <InputLabel htmlFor="agentFee">Agent Commission</InputLabel>
                                        <Input
                                            id="agentFee"
                                            error={
                                                (agentCommissionType === 0 && modGigFee) ||
                                                (agentCommissionType === 1 && (agentCommissionFee < 0 || agentCommissionFee > 100))
                                            }
                                            value={agentCommissionFee}
                                            onChange={this.handleAgentCommissionChange}
                                            type="string"
                                            readOnly={readOnly}
                                            inputprops={{
                                                inputComponent: NumberFormatCustom
                                            }}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <TextField
                                                        select
                                                        value={agentCommissionType}
                                                        onChange={this.handleCommissionTypeChange}
                                                        disabled={readOnly}
                                                        SelectProps={{
                                                            className: "select-adornment",
                                                            inputProps: { className: "select-adornment-input" }
                                                        }}
                                                    >
                                                        <MenuItem key={1} value={0}>
                                                            {currencySymbol}
                                                        </MenuItem>
                                                        <MenuItem key={2} value={1}>
                                                            %
                                                        </MenuItem>
                                                    </TextField>
                                                </InputAdornment>
                                            }
                                        />
                                        {error && error["agentCommissionFee"] ? <FormHelperText>{error["agentCommissionFee"]}</FormHelperText> : ""}
                                    </FormControl>
                                    <FormHelperText id="name-error-text">Percentage 0 to 100% and commission is not more than Gig Fee</FormHelperText>
                                </Grid>
                                        
                                  
                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                    <FormControl fullWidth error={error && error["actFee"]}>
                                        <InputLabel htmlFor="actFee">Gig Fee Paid To Act (ex Tax)</InputLabel>
                                        <Input
                                            id="actFeeAmount"
                                            type="string"
                                            value={actFee}
                                            onChange={this.handleActFeeChange}
                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                            readOnly
                                        />
                                        {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                                    </FormControl>
                                </Grid>

                                {
                                    !(booking.act?.actAdminId === currentProfile?.id && booking.createdById !== currentProfile?.id) && (
                                        <Grid item xs={12} lg={6} className="gridBookingForm">
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="adornment-amount">Commission paid to Agent</InputLabel>
                                                <Input
                                                    id="agentFeeAmount"
                                                    type="text"
                                                    value={Number(agentCommissionAmount || 0).toFixed(2)}
                                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    readOnly
                                                />
                                            </FormControl>
                                        </Grid>
                                    )
                                }

                                <Grid item xs={12} className="gridBookingForm">
                                    <FormControlLabel
                                        control={
                                            immediateInvoice ? (
                                                <Switch
                                                    color="primary"
                                                    checked={true}
                                                    onChange={this.handleImmediateInvoiceChange}
                                                    disabled={!confirmedEditable}
                                                />
                                            ) : (
                                                <Switch
                                                    color="primary"
                                                    checked={false}
                                                    onChange={this.handleImmediateInvoiceChange}
                                                    disabled={!confirmedEditable}
                                                />
                                            )
                                        }
                                        label="Immediate invoice (ignores invoice batching)"
                                    />
                                </Grid>

                            </Fragment> :   
                                    <Fragment>
                                        <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["actFee"]}>
                                                <InputLabel htmlFor="actFee">Performance Fee (ex Tax)</InputLabel>
                                                <Input
                                                    id="actFeeAmount"
                                                    type="string"
                                                    value={actFee}
                                                    onChange={this.handleActFeeChangeSuper}
                                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    readOnly={readOnly}
                                                />
                                                {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6} className="gridBookingForm">
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                            color="primary"
                                                            checked={includeSuper}
                                                            onChange={this.handleIncludeSuperFeeChanged}
                                                            disabled={readOnly}
                                                    />
                                                }
                                                label="Fee includes super"
                                            />
                                        </Grid>
                                        {booking.createdBy?.type === ProfileType.Agent.ordinal ?     
                                        <Grid item xs={12} lg={6} className="gridBookingForm">
                                            <FormControl fullWidth error={error && error["agentCommissionFee"]}>
                                                <InputLabel htmlFor="agentFee">Agent Commission</InputLabel>
                                                <Input
                                                    id="agentFee"
                                                    error={
                                                        (agentCommissionType === 0 && modGigFee) ||
                                                        (agentCommissionType === 1 && (agentCommissionFee < 0 || agentCommissionFee > 100))
                                                    }
                                                    value={agentCommissionFee}
                                                    onChange={this.handleAgentCommissionChangeSuper}
                                                    type="string"
                                                    readOnly={readOnly}
                                                    inputprops={{
                                                        inputComponent: NumberFormatCustom
                                                    }}
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <TextField
                                                                select
                                                                value={agentCommissionType}
                                                                onChange={this.handleCommissionTypeChange}
                                                                disabled={readOnly}
                                                                SelectProps={{
                                                                    className: "select-adornment",
                                                                    inputProps: { className: "select-adornment-input" }
                                                                }}
                                                            >
                                                                <MenuItem key={1} value={0}>
                                                                    {currencySymbol}
                                                                </MenuItem>
                                                                <MenuItem key={2} value={1}>
                                                                    %
                                                                </MenuItem>
                                                            </TextField>
                                                        </InputAdornment>
                                                    }
                                                />
                                                {error && error["agentCommissionFee"] ? <FormHelperText>{error["agentCommissionFee"]}</FormHelperText> : ""}
                                            </FormControl>
                                            <FormHelperText id="name-error-text">Percentage 0 to 100% and commission is not more than Gig Fee</FormHelperText>
                                        </Grid> : null}
                                    
                                        
{/*                                         
                                        <Grid item xs={12} lg={6} className="gridBookingForm">
                                            <FormControl fullWidth error={error && error["gigFee"]}>
                                                    <InputLabel htmlFor="venueFee">Gig Fee to Venue (ex Tax)</InputLabel>
                                                    <Input
                                                        type="string"
                                                        id="venueFee"
                                                        value={gigFee}
                                                        onChange={this.handleGigFeeChange.bind(this)}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        readOnly={true}
                                                    />
                                                    {error && error["gigFee"] ? <FormHelperText>{error["gigFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                        </Grid> */}

                                        {
                                            !(booking.act?.actAdminId === currentProfile?.id && booking.createdById !== currentProfile?.id) && (
                                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor="adornment-amount">Commission paid to Agent</InputLabel>
                                                        <Input
                                                            id="agentFeeAmount"
                                                            type="text"
                                                            value={Number(agentCommissionAmount || 0).toFixed(2)}
                                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                            readOnly
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            )
                                        }
                                         <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["totalFee"]}>
                                                    <InputLabel htmlFor="totalFee">Total Fee to Venue (ex Tax)</InputLabel>
                                                    <Input
                                                        type="text"
                                                        id="totalFee"
                                                        value={Number(totalFee || 0).toFixed(2)}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        readOnly={true}
                                                    />
                                                    {error && error["totalFee"] ? <FormHelperText>{error["totalFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["superFee"]}>
                                                    <InputLabel htmlFor="superFee">Super Paid to Act</InputLabel>
                                                    <Input
                                                        id="superFee"
                                                        value={superFee}
                                                        type="string"
                                                        readOnly={true}
                                                        inputprops={{
                                                            inputComponent: NumberFormatCustom
                                                        }}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    />
                                                    {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                                <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of Performance Fee paid to act`}</FormHelperText>
                                            </Grid>
                                            { !booking.id || currentProfile?.id === booking.createdById ? 
                                                <Grid item xs={12} lg={6} className="gridBookingForm">
                                                    <FormControl fullWidth error={error && error["superFee"]}>
                                                        <InputLabel htmlFor="superFee">Total Act Invoice</InputLabel>
                                                        <Input
                                                            id="actInvoiceAmount"
                                                            value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                                            type="string"
                                                            readOnly={true}
                                                            inputprops={{
                                                                inputComponent: NumberFormatCustom
                                                            }}
                                                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        />
                                                        {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                                                    </FormControl>
                                                </Grid> : null
                                            }
                                            

                                        <Grid item xs={12} md={6} className="gridBookingForm">
                                            <FormControlLabel
                                                control={
                                                    immediateInvoice ? (
                                                        <Switch
                                                            color="primary"
                                                            checked={true}
                                                            onChange={this.handleImmediateInvoiceChange}
                                                            disabled={!confirmedEditable}
                                                        />
                                                    ) : (
                                                        <Switch
                                                            color="primary"
                                                            checked={false}
                                                            onChange={this.handleImmediateInvoiceChange}
                                                            disabled={!confirmedEditable}
                                                        />
                                                    )
                                                }
                                                label="Immediate invoice (ignores invoice batching)"
                                            />
                                        </Grid>
                                    </Fragment>


                        }
                    </Fragment>
    }
            </Grid>
        ) : currentProfile && currentProfile?.type === ProfileType.Staff.ordinal ? (
            <Grid container spacing={8}>
                <Fragment>
                    {
                        createdById && createdBy && createdBy?.type === ProfileType.Agent.ordinal?
                        <Fragment>
                        <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth error={error && error["gigFee"]}>
                                <InputLabel htmlFor="venueFee">Gig Fee</InputLabel>
                                <Input
                                    type="text"
                                    id="venueFee"
                                    value={gigFee}
                                    onChange={this.handleGigFeeStaffChange.bind(this)}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                    readOnly={readOnly}
                                />
                                {error && error["gigFee"] ? <FormHelperText>{error["gigFee"]}</FormHelperText> : ""}
                            </FormControl>
                        </Grid>
                        {
                            createdBy  && createdBy.hideVenueAgencyFees ? null : 
                             <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="adornment-amount">Commission paid to Agent</InputLabel>
                                <Input
                                    id="agentFeeAmount"
                                    type="text"
                                    value={Number(agentCommissionAmount || 0).toFixed(2)}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                    readOnly
                                />
                            </FormControl>
                        </Grid>
                             
                        }
                         {
                            createdBy  && createdBy.hideActFees ? null : 
                            <Grid item xs={12} lg={6} className="gridBookingForm">
                            <FormControl fullWidth error={error && error["actFee"]}>
                                <InputLabel htmlFor="actFee">Gig Fee Paid To Act (ex Tax)</InputLabel>
                                <Input
                                    id="actFeeAmount"
                                    type="string"
                                    value={actFee}
                                    onChange={this.handleActFeeChange}
                                    startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                    readOnly
                                />
                                {error && error["actFee"] ? <FormHelperText>{error["actFee"]}</FormHelperText> : ""}
                            </FormControl>
                        </Grid>
                             
                        }
                       
                        
                        </Fragment> : 
                           <Fragment>
                           <Grid item xs={12} lg={6} className="gridBookingForm">
                               <FormControl fullWidth error={error && error["gigFee"]}>
                                   <InputLabel htmlFor="venueFee">{!legalEntityHasSuper(act?.actAdmin?.legalEntity) || !isSuperFee  ? "Gig Fee" : "Performance Fee (ex Tax)"}</InputLabel>
                                   <Input
                                       type="text"
                                       id="venueFee"
                                       value={gigFee}
                                       onChange={this.handleGigFeeStaffChange.bind(this)}
                                       startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                       readOnly={readOnly}
                                   />
                                   {error && error["gigFee"] ? <FormHelperText>{error["gigFee"]}</FormHelperText> : ""}
                               </FormControl>
                           </Grid>
                           {
                            !legalEntityHasSuper(act?.actAdmin?.legalEntity) || !isSuperFee ? null: 
                            <Fragment>
                                <Grid item xs={12} md={6} className="gridBookingForm">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                    color="primary"
                                                    checked={includeSuper}
                                                    onChange={this.handleIncludeSuperFeeChanged}
                                                    disabled={readOnly}
                                            />
                                        }
                                        label={"Fee includes super"}
                                    />
                                </Grid>
                                 <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["totalFee"]}>
                                                    <InputLabel htmlFor="totalFee">{currentProfile?.type === ProfileType.Staff.ordinal ? "Total Gig Fee (ex Tax)" : "Total Fee to Venue (ex Tax)"}</InputLabel>
                                                    <Input
                                                        type="text"
                                                        id="totalFee"
                                                        value={Number(totalFee || 0).toFixed(2)}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                        readOnly={true}
                                                    />
                                                    {error && error["totalFee"] ? <FormHelperText>{error["totalFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["superFee"]}>
                                                    <InputLabel htmlFor="superFee">Super Contribution</InputLabel>
                                                    <Input
                                                        id="superFee"
                                                        value={superFee}
                                                        type="string"
                                                        readOnly={true}
                                                        inputprops={{
                                                            inputComponent: NumberFormatCustom
                                                        }}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    />
                                                    {error && error["superFee"] ? <FormHelperText>{error["superFee"]}</FormHelperText> : ""}
                                                </FormControl>
                                                <FormHelperText id="name-error-text">{`Percentage ${percentageFeeSuper}% of gig fee paid to act`}</FormHelperText>
                                            </Grid>
                                             <Grid item xs={12} lg={6} className="gridBookingForm">
                                                <FormControl fullWidth error={error && error["superFee"]}>
                                                    <InputLabel htmlFor="superFee">Act Invoice Amount (ex Tax)</InputLabel>
                                                    <Input
                                                        id="actInvoiceAmount"
                                                        value={includeSuper ? parseFloat(parseFloat(actFee??0) - parseFloat(superFee??0)).toFixed(2) : parseFloat(actFee??0).toFixed(2)}
                                                        type="string"
                                                        readOnly={true}
                                                        inputprops={{
                                                            inputComponent: NumberFormatCustom
                                                        }}
                                                        startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                                                    />
                                                    {error && error["actInvoiceAmount"] ? <FormHelperText>{error["actInvoiceAmount"]}</FormHelperText> : ""}
                                                </FormControl>
                                            </Grid>
                            </Fragment>
                           
                           }
                           </Fragment>
                    }
                 
                </Fragment>
               
                <Grid item xs={12} lg={6} className="gridBookingForm">
                    {/* <FormControl fullWidth error={error && error["actFee"]}>
                        <InputLabel htmlFor="extraGigFee">Extra Set Fee</InputLabel>
                        <Input
                            id="extraGigFee"
                            type="number"
                            value={extraGigFee}
                            disabled
                            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
                            endAdornment={
                                extraGigFee > 0 && (
                                    <InputAdornment position="end">
                                        <Button
                                            id="btn-respond-2"
                                            fullWidth
                                            className={
                                                extraGigFeeApprovalById ? "extra-gig-fee-inline-button-disabled" : "extra-gig-fee-inline-button"
                                            }
                                            onClick={this.openApprovalDialog}
                                            disabled={extraGigFeeApprovalById}
                                        >
                                            {extraGigFeeApprovalById ? (isApproved ? "Approved" : "Declined") : "Respond"}
                                        </Button>
                                    </InputAdornment>
                                )
                            }
                        />
                        {error && error["extraGigFee"] ? (
                            <FormHelperText>{error["extraGigFee"]}</FormHelperText>
                        ) : (
                            <FormHelperText>Extra set fee will be included in the invoice when you have approved it</FormHelperText>
                        )}
                    </FormControl>
                 */}
                </Grid>
                <Grid item xs={12} className="gridBookingForm">
                    <FormControlLabel
                        control={
                            immediateInvoice ? (
                                <Switch color="primary" checked={true} onChange={this.handleImmediateInvoiceChange} disabled={readOnly || !confirmedEditable} />
                            ) : (
                                <Switch color="primary" checked={false} onChange={this.handleImmediateInvoiceChange} disabled={readOnly || !confirmedEditable} />
                            )
                        }
                        label="Immediate invoice (ignores invoice batching)"
                    />
                </Grid>

                {/* <Dialog
                    open={this.state.approvalDialogOpen}
                    onClose={this.closeApprovalDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Approve Extra Set Fee?</DialogTitle>
                    <DialogContent>
                        <div>
                            <Grid container spacing={16}>
                                <Grid item xs={12}>
                                    <DialogContentText id="alert-dialog-description">
                                        {"Extra set fee will be included in the invoice when you have approved it. Are you sure to approve extra " +
                                            currencySymbol +
                                            extraGigFee +
                                            " gig fee?"}
                                    </DialogContentText>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="approval_by_name"
                                        label="Approval By"
                                        margin="dense"
                                        fullWidth
                                        value={
                                            this.props.profileStore.currentProfile?.firstName + " " + this.props.profileStore.currentProfile?.lastName
                                        }
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="approval_date"
                                        label="Approval Date"
                                        margin="dense"
                                        fullWidth
                                        value={moment(new Date()).format("D MMM YYYY")}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.checked} onChange={this.handleCheckedChange} value="checked" />}
                                            label="I have read the statement above and willing to be responsible with the result"
                                        />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeApprovalDialog} color="secondary">
                            Close
                        </Button>
                        <Button onClick={this.handleRequestDeclinedClick} color="primary" disabled={!this.state.checked}>
                            Decline
                        </Button>
                        <Button onClick={this.handleRequestApprovedClick} color="primary" autoFocus disabled={!this.state.checked}>
                            {"Approve " + currencySymbol + extraGigFee + " Extra Set Fee"}
                        </Button>
                    </DialogActions>
                </Dialog>
             */}
            </Grid>
        ) : (
            ""
        )}
            </React.Fragment>
        );
    }
}
BookingFeeDetails.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(styles)(BookingFeeDetails);
